import { Container, Row, Col } from "react-bootstrap";

import { info } from "./Data";
import { MailchimpForm } from "./MailchimpForm";
import logo from "../assets/img/logo.png";
import linkedIn from "../assets/img/nav-icon1.svg";
import github from "../assets/img/nav-icon4.jpg";

export const Footer = () => {
  return (
    <footer className="footer">
      <Container>
        <Row>
          <MailchimpForm />
          <Col
            size={12}
            sm={6}
            className="d-flex justify-content-center justify-content-sm-start align-items-center"
          >
            <img src={logo} alt="Logo" />
          </Col>
          <Col size={12} sm={6} className="text-center text-sm-end">
            <p></p>
            <p className="mt-4">
              <b>Always open to new opportunities.</b>
            </p>
            <p className="mt-0">
              <b>Email:</b> hassanfzl11@gmail.com 
            </p>
            <p className="mt-0">
              <b>Contact no.:</b> +923004561126
            </p>
            <div className="social-icon pt-2">
              <a href={info.linkedin}>
                <img src={linkedIn} alt="" />
              </a>
              <a href={info.github}>
                <img src={github} style={{ transform: "scale(1.4)" }} alt="" />
              </a>
            </div>
          </Col>
        </Row>
        <Row className="text-center">
          <small>Copyright 2022. All Rights Reserved</small>
        </Row>
      </Container>
    </footer>
  );
};
